export const last = <T>(value: T[]): T => {
  return value[value.length - 1];
};

export const unique = <T>(value: T[]): T[] => {
  return [...new Set(value).values()];
};
